import { memo, type FC } from 'react';

import { Tag } from '../../../../Elements/Tag/index.tsx';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.tsx';
import { TitleWrapper } from './styled.ts';

interface TitleContentProps {
  title?: string;
  tooltip?: string;
  tag?: string;
}

export const TitleContent: FC<TitleContentProps> = memo(function TitleContent({ title, tooltip, tag }) {
  return (
    <TitleWrapper data-testid='title-wrapper'>
      <span>{title}</span>
      {tooltip && <InfoTooltipIcon tooltip={tooltip} size={24} dataTestId='section-title-tooltip' />}
      {tag && <Tag title={tag} />}
    </TitleWrapper>
  );
});
